
RLEntityAssetsTableRowOps.$inject = ['$compile'];
export function RLEntityAssetsTableRowOps($compile: ng.ICompileService) {
    var directive: ng.IDirective = {
        template: require("/assets/app/templates/entity-assets-table-row-ops.html")
    };
    return directive;
}


